// Fixes Add to cart for quantity breaks (1 Plush, Buy 2, Buy 4, ...).
// main-origin.js builds the cart request inconsistently:
// - For bundles with more than one item it removes `id` and `quantity` but never
//   adds the `items[]` fields, so Shopify rejects the request ("sold out").
// - For a single item it sends both `id`/`quantity` and `items[]`, so Shopify
//   adds the item twice.
// This makes `items[]` the only source of what gets added, rebuilding it from the
// colors picked for each item in the selected bundle when it is missing.
(function () {
  var originalFetch = window.fetch;

  function selectedBundleVariants(body) {
    var sectionInput = document.querySelector('[name="section-id"][value="' + body.get('section-id') + '"]');
    var productInfo = sectionInput && sectionInput.form ? sectionInput.form.closest('product-info') : null;
    var quantityBreaks = (productInfo || document).querySelector('quantity-breaks');
    if (!quantityBreaks || !quantityBreaks.selectedVariants) return null;

    var radios = Array.prototype.slice.call(quantityBreaks.querySelectorAll('input[type="radio"]'));
    var checked = quantityBreaks.querySelector('input[type="radio"]:checked');
    if (!checked) return null;
    var quantity = parseInt(checked.value) || 1;

    var variants = quantityBreaks.selectedVariants['input_' + (radios.indexOf(checked) + 1)];
    if (!Array.isArray(variants) || variants.length !== quantity) {
      variants = Object.values(quantityBreaks.selectedVariants).find(function (v) {
        return Array.isArray(v) && v.length === quantity;
      });
    }
    return variants || null;
  }

  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : input && input.url;
      var body = init && init.body;
      if (url && url.indexOf('/cart/add') !== -1 && body instanceof FormData) {
        if (body.has('items[0][id]')) {
          body.delete('id');
          body.delete('quantity');
        } else if (!body.has('id')) {
          var variants = selectedBundleVariants(body);
          if (variants) {
            var counts = {};
            var order = [];
            variants.forEach(function (id) {
              id = String(id);
              if (!counts[id]) order.push(id);
              counts[id] = (counts[id] || 0) + 1;
            });
            order.forEach(function (id, i) {
              body.append('items[' + i + '][id]', id);
              body.append('items[' + i + '][quantity]', counts[id]);
            });
          }
        }
      }
    } catch (e) {}
    return originalFetch.apply(this, arguments);
  };
})();
